export default "__VITE_ASSET__8fFQlLNX__"